// extracted by mini-css-extract-plugin
export default {"flexbox-container":"ProjectGallery_flexbox-container__dAh2Z"};